export default {"src":"/_next/static/media/flag-ua.b4bde573.svg","height":17,"width":21,"blurWidth":0,"blurHeight":0};